import { MuiF } from '../../../../../Mui/F/Function/module/MuiF.js';
import { MShopUtilF } from '../../../../../MShop/Util/F/Function/module/MShopUtilF.js';
import { go } from 'fxjs/es';
import { $delegate } from 'fxdom/es';
import { NessLabsSettingMotionMuiF } from '../Mui/module/NessLabsSettingMotionMuiF.js';

export const openMotionSelector = async (motion_data, ckb) => {
  const { type } = motion_data;
  return MuiF.openFrame(NessLabsSettingMotionMuiF.frame, async (frame, page, [tab]) => {
    const is_mobile = MShopUtilF.isMobile();
    frame.title = type;
    frame.hide_frame_button_type = 'X';
    frame.height = 300;
    frame.always_remove = true;
    frame.animation = true;
    frame.prev_frame_show = true;
    frame.is_modal = false;
    // frame.appended = $.frame_close_bg;
    if (is_mobile) {
      MShopUtilF.bodyFixed$(true);

      frame.closed = () => {
        MShopUtilF.bodyFixed$(false);
      };
    }

    tab.makeData = () => motion_data;
    tab.appended = (tab_el) => {
      go(
        tab_el,
        $delegate('click', '.option', async ({ currentTarget }) => {
          const { value, name } = currentTarget.dataset;
          await ckb({ type, value, name, frame_option: motion_data.is_frame_select });
          MuiF.removeFrame();
        }),
      );
    };
  });
};
